export default function parseQueryString(queryString) {
  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  pairs.forEach((pair) => {
    const parts = pair.split('=');
    query[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1] || '');
  });
  return query;
}
